import script from "./AdminControlPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminControlPassword.vue?vue&type=script&setup=true&lang=js"

import "./AdminControlPassword.vue?vue&type=style&index=0&id=5f0ec1a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f0ec1a4"]])

export default __exports__